module.exports = __webpack_public_path__ + "img/zombieoffice_0.26caf1a7.jpg";